import { useState, useEffect, useRef } from "react";
import { functions } from "../firebaseConfig";
import { httpsCallable } from "firebase/functions";

import style from "./Inbound.module.css";
import ErrMsg from "../ErrMsg";
import { BlockInput, LineTextarea } from "../components/Input";

export default () => {
    const [loading, setLoading] = useState<boolean>(false);
    const init = useRef<boolean>(true);

    const [name, setName] = useState<string>("");
    const [nameError, setNameError] = useState<string>("");

    // useEffect(() => {
    //     if (init.current) return;
    //     if (!name) {
    //         setNameError(ErrMsg["name/empty"]);
    //     } else {
    //         setNameError("");
    //     }
    // }, [name]);

    const [company, setCompany] = useState<string>("");
    const [companyError, setCompanyError] = useState<string>("");

    // useEffect(() => {
    //     if (init.current) return;
    //     if (!company) {
    //         setCompanyError(ErrMsg["company/empty"]);
    //     } else {
    //         setCompanyError("");
    //     }
    // }, [company]);

    const [email, setEmail] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");

    // useEffect(() => {
    //     if (init.current) return;
    //     if (!email) {
    //         setEmailError(ErrMsg["email/empty"]);
    //     } else if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(email)) {
    //         setEmailError(ErrMsg["email/invalid"]);
    //     } else {
    //         setEmailError("");
    //     }
    // }, [email]);

    const [contact, setContact] = useState<string>("");
    const [contactError, setContactError] = useState<string>("");

    // useEffect(() => {
    //     if (init.current) return;
    //     if (!contact) {
    //         setContactError(ErrMsg["contact/empty"]);
    //     } else {
    //         setContactError("");
    //     }
    // }, [contact]);

    const [content, setContent] = useState<string>("");
    const [contentError, setContentError] = useState<string>("");

    // useEffect(() => {
    //     if (init.current) return;
    //     if (!content) {
    //         setContentError(ErrMsg["content/empty"]);
    //     } else {
    //         setContentError("");
    //     }
    // }, [content]);

    useEffect(() => {
        setTimeout(() => {
            init.current = false;
        }, 10);
    }, []);

    const push = async () => {
        let valid = true;

        if (!name) {
            setNameError(ErrMsg["name/empty"]);
            valid = false;
        } else {
            setNameError("");
        }

        if (!company) {
            setCompanyError(ErrMsg["company/empty"]);
            valid = false;
        } else {
            setCompanyError("");
        }

        if (!email) {
            setEmailError(ErrMsg["email/empty"]);
            valid = false;
        } else if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(email)) {
            setEmailError(ErrMsg["email/invalid"]);
            valid = false;
        } else {
            setEmailError("");
        }

        if (!contact) {
            setContactError(ErrMsg["contact/empty"]);
            valid = false;
        } else {
            setContactError("");
        }

        if (!content) {
            setContentError(ErrMsg["content/empty"]);
            valid = false;
        } else {
            setContentError("");
        }

        if (!valid) return;

        setLoading(true);

        return httpsCallable(
            functions,
            "inbound"
        )({
            name,
            company,
            email,
            contact,
            content,
        })
            .then(() => {
                setLoading(false);

                alert("솔루션 문의를 성공적으로 요청하였습니다. 빠른 시일 내에 연락드리겠습니다!");
                // 여기서 리셋하면 useEffect 때문에 에러 뜸. 그래서 주석처리 함.
                setName("");
                setCompany("");
                setEmail("");
                setContact("");
                setContent("");
            })
            .catch((err) => {
                console.error(err.message);
                setLoading(false);

                switch (err.message.split("/")) {
                    case "name":
                        setNameError(ErrMsg[err.message]);
                        break;
                    case "company":
                        setCompanyError(ErrMsg[err.message]);
                        break;
                    case "email":
                        setEmailError(ErrMsg[err.message]);
                        break;
                    case "contact":
                        setContactError(ErrMsg[err.message]);
                        break;
                    case "content":
                        setContentError(ErrMsg[err.message]);
                        break;
                }

                return false;
            });
    };

    return (
        <>
            <h4 className={style["text--inbound"]}>문의하기</h4>
            <div className={style["wrapper--inbound"]}>
                <BlockInput type="text" placeholder="성함" value={name} setValue={setName} error={nameError} />
                <BlockInput
                    type="text"
                    placeholder="회사명"
                    value={company}
                    setValue={setCompany}
                    error={companyError}
                />
                <BlockInput type="text" placeholder="이메일" value={email} setValue={setEmail} error={emailError} />
                <BlockInput
                    type="text"
                    placeholder="연락처"
                    value={contact}
                    setValue={setContact}
                    error={contactError}
                />
                <LineTextarea
                    placeholder="문의 내용"
                    value={content}
                    setValue={setContent}
                    maxHeight={480}
                    error={contentError}
                />

                <button className={[style["button--inbound"], loading && style["loading"]].join(" ")} onClick={push}>
                    지금 문의하기
                </button>
            </div>
        </>
    );
};
